import { PaymentModuleId } from '@foundation/apis/payments';
import Clarity from '@microsoft/clarity';
import { useAuth } from '@shared/auth';
import { useTranslation } from '@shared/localization';
import { JSX } from 'react';

import { RedirectStatus } from '@/components/contexts/params';
import { PayButton } from '@/components/pages/stored-instruments/utils/PayButton';
import { useUserFriendlyPaymentModuleName } from '@/hooks/useUserFriendlyPaymentModuleName';
import { triggerErrorToast } from '@/libs/toasts';
import Logger, { LoggerOrigin } from '@/services/Logger';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';
import SubsidiaryService from '@/services/subsidiary/SubsidiaryService';
import TelemetryService from '@/services/telemetry/TelemetryService';

interface IPayInSubsidiaryBtnProps {
  navigation?: JSX.Element | null;
}

export function PayInSubsidiaryBtn({ navigation }: IPayInSubsidiaryBtnProps) {
  const { accessToken } = useAuth();
  const { t } = useTranslation();
  const paymentModuleT = useUserFriendlyPaymentModuleName();

  return (
    <div className="flex space-x-2">
      {navigation}
      <PayButton
        onClick={() => {
          const currentPage = NavigationService.getInternalPage();
          NavigationService.navigateTo({ page: InternalPage.StatusProcessing });
          SubsidiaryService.authorise(accessToken ?? '')
            .then(() => {
              NavigationService.navigateTo({
                page: InternalPage.PaymentInSubsidiaryStatusSuccess,
              });
              Clarity.setTag('pay', [
                RedirectStatus.Success,
                paymentModuleT(PaymentModuleId.PaymentAtSubsidiary),
              ]);
            })
            .catch((err) => {
              NavigationService.navigateTo(currentPage);
              TelemetryService.trackException(err, 'SubsidiaryBtn');
              Logger.error(
                LoggerOrigin.ReactComponent,
                'Payment at subsidiary failed',
                err,
              );
              triggerErrorToast(
                t('Something went wrong!'),
                t('Failed to authorize payment at subsidiary.'),
              );
              Clarity.setTag('pay', [
                RedirectStatus.Failure,
                paymentModuleT(PaymentModuleId.PaymentAtSubsidiary),
              ]);
            });
        }}
      />
    </div>
  );
}
